import {Modal} from 'antd'

import eventBus from "../../../utils/EventBus"
import {useEffect} from "react";


export default function MessageModal() {

    useEffect(() => {
        const handleMessage = (message) => {
            switch (message.type) {
                case 'success':
                    return success(message)
                case 'warning':
                    return warning(message)
                case 'error':
                    return error(message)
                default:
                    return info(message)
            }
        }

        eventBus.subscribe('message-modal', handleMessage);

        return () => eventBus.unsubscribe('message-modal')
    })


    function info(message) {
        Modal.info({
            title: message.title,
            content: (
                message.content
            ),
            onOk() {
            },
        });
    }

    function success(message) {
        Modal.success({
            content: message.content,
        });
    }

    function warning(message) {
        Modal.warning({
            title: message.title,
            content: message.content,
        });
    }

    function error(message) {
        Modal.error({
            title: message.title,
            content: message.content,
        });
    }

    return <></>
};